import React from "react";
import {TableDateSearchProvider} from "../../../admin/Context/TableDateSearchContext.jsx";
import {SystemProviders} from "./SystemProviders.jsx";
import {ResponsiveView} from "../../../components/index.jsx";
import {Devices} from "../../../components/ResponsiveView/consts.js";

export const SystemProvidersWrapper = () => {
    return (
        <TableDateSearchProvider localStorageKey={"admin-system-providers-date-range"}>
            <ResponsiveView devices={[Devices.desktop, Devices.mobile]}>
                <SystemProviders />
            </ResponsiveView>
        </TableDateSearchProvider>
    );
};
